import * as React from "react"
import { cn } from "../../lib/utils"

const glassVariantMap = {
  purple: "card-glass-purple",
  mint: "card-glass-mint",
  magenta: "card-glass-magenta",
  orange: "card-glass-orange",
  lemon: "card-glass-lemon",
  blue: "card-glass-blue",
}

const Card = React.forwardRef(({ className, elevated, glass = true, glassVariant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "rounded-lg border shadow-sm",
      glass && "card-glass card-glass-float",
      glass && glassVariant && glassVariantMap[glassVariant],
      elevated 
        ? "bg-[var(--color-card-elevated)] text-[var(--color-card-elevated-foreground)]" 
        : "bg-card text-card-foreground",
      className
    )}
    {...props}
  />
))
Card.displayName = "Card"

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex flex-col space-y-1.5 p-4 sm:p-6", className)}
    {...props}
  />
))
CardHeader.displayName = "CardHeader"

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      "text-2xl font-semibold leading-none tracking-tight",
      className
    )}
    {...props}
  />
))
CardTitle.displayName = "CardTitle"

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
))
CardDescription.displayName = "CardDescription"

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-4 sm:p-6 pt-0", className)} {...props} />
))
CardContent.displayName = "CardContent"

export { Card, CardContent, CardDescription, CardHeader, CardTitle }
